import apolloClient from 'utils/apolloClient';
import CustomLanding from 'assets/graphql/queries/CustomLanding.graphql';

/**
 * @param slug {string} required
 * @return data from CustomLanding query
 * @example
 */

const getCustomLanding = async slug => {
  try {
    const { data } = await apolloClient.query({
      query: CustomLanding,
      variables: { slug },
    });

    return data.landing;
  } catch (e) {
    throw new Error('Error fetching custom landing', e);
  }
};

export { getCustomLanding };
